import { DataSource, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierQualificationDetailsQuickInfo extends Layout {
    labelQualificationDetails: Label;
    labelStatus: Label;
    labelStatusCaption: Label;
    labelTitle: Label;
    sourceBrltlBillingFreightGroup: DataSource;
    textboxPayeeId: Textbox;
}
